import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IncrediField } from 'incredi-ui';
import { ref, watch } from 'vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'editDescriptionCell',
  props: {
    ghost: { type: Boolean },
    description: null,
    maxInputLength: null,
    minInputLength: { default: 1 }
  },
  emits: ["update:description", "focusWithin", "blurWithin"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:description', description: string): void; (e: 'focusWithin'): void; (e: 'blurWithin'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { ghost: boolean, description: string, maxInputLength?: number, minInputLength: number }



const localValue = ref('');

watch(
  () => props.description,
  curr => {
    localValue.value = curr;
  },
  { immediate: true },
);

// eslint-disable-next-line no-unused-vars


const handleEditDescription = () => {
  emit('blurWithin');
  if (localValue.value === props.description) {
    return;
  }
  if (localValue.value.length < props.minInputLength) {
    localValue.value = props.description;
    return;
  }
  emit('update:description', localValue.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediField), {
        clearable: "",
        name: "description",
        size: "tiny",
        fieldType: "text",
        maxlength: __props.maxInputLength,
        modelValue: localValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
        ghost: __props.ghost,
        class: "m-1 w-[210px]",
        onBlurWithin: handleEditDescription,
        onFocusWithin: _cache[1] || (_cache[1] = ($event: any) => (emit('focusWithin'))),
        onKeydown: _cache[2] || (_cache[2] = _withKeys((event) => event?.target?.blur(), ["enter"]))
      }, null, 8, ["maxlength", "modelValue", "ghost"])
    ]),
    _: 1
  }))
}
}

})